<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Financial Position 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th width="110px">Src.Code</th>
                            <th >Description</th>
                            <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanlalu | moment("MMM YYYY")}}</th>
                            <th v-else style="text-align:right" width="140px">Previous Month</th>
                            <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMM YYYY")}}</th>
                            <th v-else style="text-align:right" width="140px">Month to date</th>
                            <th v-if="filter.tgltahunlalu" style="text-align:right" width="140px">{{filter.tgltahunlalu | moment("MMM YYYY")}}</th>
                            <th v-else style="text-align:right" width="140px">Begining Year</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                            <td :class="row.kelas">{{row.kode}}</td>
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillPrevmonth(row)" style="text-align:right">{{row.prevmonth | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillSdAkhir(row)" style="text-align:right">{{row.sdakhir | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillSdAwal(row)" style="text-align:right">{{row.sdawal | numFormat("0,0.00") }}</td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

        <b-modal v-model="drillConfirmation" scrollable size="md" title="Drilldown Confirmation" hide-footer>
            <span>Show Detail value of <strong>{{drillSrc.uraianfmt}}</strong> ?</span>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="drillNewtab" class="mt-1 ml-2">Open New Tab</b-form-checkbox>
            <b-row class="justify-content-center mt-1">
                <b-button variant="primary" class="ml-2" @click="drillAction('GL')" > Show in GL</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('TB')" > Show in TB</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('MODUL')" v-if="(drillModul)"> Show in subModul</b-button>
                <b-button variant="secondary" class="ml-2" @click="drillConfirmation=false" > Cancel</b-button>
            </b-row>
        </b-modal>

    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import fp from "../../apis/fp";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      arPostgroups:[],
      apPostgroups:[],
      advancegroups:[],
      inventorygroups:[],
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[],
      drillConfirmation:false,
      drillSrc:{}, drillCol:'', 
      drillModul:'',drillNewtab:1
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
        const lines = await fp.layout({layout : newval});
        const hasil = lines.reduce((newArr, line) => {
            if (line.item_hapus !== 1) newArr.push(line);
            return newArr;
        }, []);          
          this.rptLines=hasil;
      }
  },
created: async function (){
    const [layouts,arPostgroups,apPostgroups,advancegroups,inventorygroups] = await Promise.all([fp.layout_combo(),fp.arPostgroup(),fp.apPostgroup(),fp.advancegroup(),fp.inventorygroup()]) ;  
    this.layouts = layouts;    
    this.arPostgroups = arPostgroups;    
    this.apPostgroups = apPostgroups;    
    this.advancegroups = advancegroups;    
    this.inventorygroups = inventorygroups;    
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
    this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        // this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // const tglbulanlalu = moment(query.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
    this.filter.tglbulanini= tgl2;
        
  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
        this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        // this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tglbulanini= tgl2;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.rptLines= await fp.rptfp(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await fp.rptfpprint(model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await fp.rptfpexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillPrevmonth: function(data){
        if (data.kode) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='prevMoth';
            this.drillConfirmation=true;
        }
    },
    drillSdAkhir: function(data){
        if (data.kode) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAkhir';
            this.drillConfirmation=true;
        }
    },
    drillSdAwal: function(data){
        if (data.kode) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAwal';
            this.drillConfirmation=true;
        }
    },
 
    cekModule: function(kodeacc) {
        this.drillModul='';
        // if (kodeacc.startsWith('140')) {
        //     this.drillModul='receivable.araging';
        // } else if (kodeacc.startsWith('141')) {
        //     this.drillModul='advance.advaging';
        // } else if (kodeacc.startsWith('142')) {
        //     this.drillModul='accounting.loanaraging';
        // } else if (kodeacc.startsWith('150')) {
        //     this.drillModul='logistic.rptbalance';
        // } else if (kodeacc.startsWith('210')) {
        //     this.drillModul='payable.apsummary';
        // }    
        const inventory = this.inventorygroups.find(item => item.kodeacc==kodeacc);
        if (inventory) {
            this.drillModul='logistic.rptbalance';
            return;
        }
        const advance = this.advancegroups.find(item => item.advAcc==kodeacc);
        if (advance) {
            this.drillModul='advance.advaging';
            return;
        }
        const ar = this.arPostgroups.find(item => item.kodeacc==kodeacc);
        if (ar) {
            this.drillModul='receivable.araging';
            return;
        }
        const ap = this.apPostgroups.find(item => item.kodeacc==kodeacc);
        if (ap) {
            this.drillModul='payable.apsummary';
            return;
        }
    },
    drillAction(drillTarget){
        let drillRoute;
        switch (drillTarget) {
            case 'TB':
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='prevMoth') {
                    var tgl2 = moment(`${this.filter.tglbulanlalu.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: tgl2.format('YYYY-MM-DD')}};
                }                    
                break;
        
            case 'MODUL':
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='prevMoth') {
                    var tgl2 = moment(`${this.filter.tglbulanlalu.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: tgl2.format('YYYY-MM-DD')}};
                }                    
                
                break;
        
            default:
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='prevMoth') {
                    var tgl2 = moment(`${this.filter.tglbulanlalu.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: tgl2.format('YYYY-MM-DD')}};
                }                    
                break;
        }
        if (drillRoute) {
            if (this.drillNewtab==1) {
                const routeData = router.resolve(drillRoute);
                window.open(routeData.href, '_blank');
            } else {
                router.push(drillRoute);                
            }
        }
    },
    close(){
      router.push("/accounting/home");
    }
  }
};
</script>
